var Main = require('./Main.js');
require('es6-promise').polyfill();

window.app = new Main();